import { call, put, takeEvery } from 'redux-saga/effects'
import { CapabilitiesType, types } from '../types/capabilties'
import { trace } from '../services/common'
import * as actions from '../actions/capabilities'
import * as services from '../services/capability'

export function* getCapabilitiesSaga(action: CapabilitiesType) {
  try {
    const list = yield call(services.getCapabilities)
    yield put(actions.getCapabilitiesSuccess(list))
  } catch (err) {
    trace(err)
    yield put(actions.getCapabilitiesFailure(err.message))
  }
}

export function* capabilitiesWatcher() {
  yield takeEvery(types.GET_CAPABILITIES__STARTED, getCapabilitiesSaga)
}
